export default (editor, mdlClass, title, content) => {
    const modal = editor.Modal;
    const mdlDialog = modal.getContentEl().parentElement.parentElement;
    mdlDialog.className += ' ' + mdlClass;
    modal.setTitle(`<div>${title}</div>`);
    modal.setContent(content);
    modal.open();
    modal.getModel().once('change:open', function () {
        mdlDialog.className = mdlDialog.className.replace(mdlClass, '');
    });
}